'use client'

import type { Data } from '@repo/strapi'
import { useTranslations } from 'next-intl'
import AppLink from '@/components/elementary/AppLink'
import CkEditorCSRRenderer from '@/components/elementary/CkEditorRenderer/CkEditorCSRRenderer'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import { PRICING_CTA_SECTIONS } from '@/constants/pricing.constants'
import { createTrackingContext } from '@/lib/analytics/analytics'
import { cn } from '@/lib/styles'

import styles from '../featureComparison/FeatureCell.module.css'

export function BillingDetails({
	title,
	button,
	price,
	priceUnderline,
}: {
	title?: Data.Component<'shared.featured-plan-v1'>['title'] | null
	button?: Data.Component<'shared.featured-plan-v1'>['button'] | null
	price?: Data.Component<'shared.featured-plan-v1'>['price'] | null
	priceUnderline?: Data.Component<'shared.featured-plan-v1'>['priceUnderline'] | null
}) {
	const t = useTranslations('Pricing')

	return (
		<div className="pt-6 lg:pt-0">
			{price ? (
				<div className="lok-text-display-large mb-2 text-neutral-light-100">
					{t('dollar')}
					{price}
					<span className="lok-text-display-large">{t('mo')}</span>
				</div>
			) : null}

			{priceUnderline ? (
				<div className="mb-5 lg:mb-7">
					<CkEditorCSRRenderer
						htmlContent={priceUnderline}
						className={cn(
							styles['table-cell-content'],
							'xl:whitespace-nowrap text-neutral-light-100',
						)}
						defaultTypography="bodyMedium"
					/>
				</div>
			) : null}

			{button?.link?.href ? (
				<AppLink
					variant="primary"
					inverted
					size="large"
					href={button?.link?.href}
					openExternalInNewTab={button?.link?.newTab ?? false}
					className="w-full shrink-0"
					trackingContext={createTrackingContext({
						plan: title ?? undefined,
						planSection: PRICING_CTA_SECTIONS.FEATURED,
					})}
				>
					{button?.icon ? (
						<div className="relative size-6 shrink-0">
							<BasicImage fill loading="lazy" component={button?.icon} className="object-contain" />
						</div>
					) : null}
					{button?.link?.label}
				</AppLink>
			) : null}
		</div>
	)
}
